<template>
  <div>
    <div v-if="show">
      <template v-if="$has('FWS-NXDD-TKJL-TK')">
        <el-button
          v-if="current.refundWay === 'CASH_PAY'"
          class="table-button table-button-success"
          icon="el-icon-success"
          @click="handlePayment('cashpay', current)"
          v-track
          trackCode="reverseRefundList-4"
        >确认退款</el-button>
        <template v-if="current.refundWay === 'BANK_CARD'">
          <el-button
            class="table-button table-button-success" icon="el-icon-success" @click="handlePayment('online', current)"
            v-track
            trackCode="reverseRefundList-5"
          >
            线上退款
          </el-button>
          <el-button
            class="table-button table-button-success" icon="el-icon-success" @click="handlePayment('offline', current)"
            v-track
            trackCode="reverseRefundList-6"
          >
            线下退款
          </el-button>
        </template>
      </template>
      <el-button
        class="table-button table-button-danger" icon="el-icon-error" @click="handleOperateState(3, current)" v-if="$has('FWS-NXDD-TKJL-QX')"
        v-track
        trackCode="reverseRefundList-7"
      >
        取消
      </el-button>
    </div>
    <operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="paramsObj"
      :text-config.sync="textConfig"
      :loading="submitLoading"
      @submit="handleOperate"
    />
    <refund-operate-dialog
      :visible.sync="isOperateShow"
      :type="refundType"
      @success="handleOperateStateResults"
      :refundOrderNo.sync="refundOrderNo"
      :data-obj="refundOrderObj"
    />
  </div>
</template>

<script>
import { getRefundChannelCancel } from '@/api/refund';
import refundOperateDialog from './refund-operate-dialog';

export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: { refundOperateDialog },
  data() {
    return {
      isOperateStateShow: false,
      paramsObj: {},
      textConfig: {},
      submitLoading: false,
      isOperateShow: false,
      refundType: '',
      refundOrderNo: '',
      refundOrderObj: {},
    };
  },
  methods: {
    handleOperateState(operation, row) {
      this.paramsObj = {
        refundOrderNo: row.refundOrderNo,
        operation,
        cancelRemark: '',
      };
      const list = {
        3: {
          title: '提示',
          messageTip: '是否取消该退款单，取消后无法撤销',
          isPass: true,
        },
      };
      this.textConfig = list[operation] || '-';
      this.isOperateStateShow = true;
    },
    async handleOperate(params) {
      try {
        this.submitLoading = true;
        await getRefundChannelCancel(params);
        this.$message.success('操作成功！');
        this.submitLoading = false;
        this.isOperateStateShow = false;
        this.$emit('success');
      } catch (error) {
        console.log(error);
        this.submitLoading = false;
      }
    },
    handleOperateStateResults() {
      this.$emit('success');
    },
    handlePayment(type, row) {
      this.refundType = type;
      this.refundOrderNo = row?.refundOrderNo || '';
      this.isOperateShow = true;
      this.refundOrderObj = row;
    },
  },
};
</script>
